import { render } from "./TableAccordionItem.vue?vue&type=template&id=baad54e2&scoped=true"
import script from "./TableAccordionItem.vue?vue&type=script&lang=js"
export * from "./TableAccordionItem.vue?vue&type=script&lang=js"

import "./TableAccordionItem.vue?vue&type=style&index=0&id=baad54e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baad54e2"]])

export default __exports__